import s from "styled-components";
import BaseFooter from "_c/footer";

const Footer = s(BaseFooter)`
  margin-top: auto;
`;
export default Footer;
